import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import aboutimg from "../../../Image/aboutimg.png"
import { BsJournals } from 'react-icons/bs';
import { FaUserFriends } from 'react-icons/fa';
import axios from 'axios';
import { BASE_URL } from '../../../insightConfig/insightConfig';

const NeetTestSeriesCards = ({ testSeries, heading }) => {
    console.log(testSeries);
    const [subjects, setSubjects] = useState([]);
    function isValidUrl(string) {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    }
    console.log(subjects);

    useEffect(() => {
        axios.get(BASE_URL + '/neet/user/subjects').then(res => {
            setSubjects(res.data.data);
        }).catch((error) => {
            console.log(error);
        })

    }, [])
    return (
        <>
            <div className='AllCardBackground'>
                <h1 className="fw-bold fs-4 text-center py-0 my-0 text-uppercase text-danger">{heading}</h1>
                <div className='AllCard_Box'>
                    {testSeries.map((card, index) => (
                        <div className="card Allcard AllDashboard" key={index}>
                            <Link to={`/neet/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className='text-decoration-none text-black'>
                                <img src={isValidUrl(card.Image) ? card.Image : aboutimg} className="card-img-top" alt={card.CourseTitle} style={{ height: "140px" }} />
                            </Link>
                            <div className="card-body All-bg">
                                <Link to={`/neet/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className='text-decoration-none text-black'>
                                    {card.CourseTitle ? <h6 className="fw-bold overflow-hidden" style={{}}>{card.CourseTitle}</h6> : <h6 className="fw-bold overflow-hidden" style={{}}>{card.Title}</h6>}
                                </Link>
                                <hr />
                                <div className="d-flex justify-content-between align-items-center">
                                    <Link to="#" className="card-link list-group-item">
                                        {card.TopicCount ? <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.TopicCount} LESSONS`}</h6> : <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.QuizCount || 0} Tests`}</h6>}
                                        {card.SubscriberCount && <h6 className='d-flex align-items-center'><FaUserFriends className='me-1' /> {card.SubscriberCount} SUBSCRIBERS</h6>}
                                    </Link>
                                    <Link to={`/neet/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className="btn-start list-group-item">START</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='AllCardBackground'>
                <h1 className="fw-bold fs-4 text-center py-0 my-0 text-uppercase text-danger">Customised Test Series</h1>
                <div className='AllCard_Box'>
                    {subjects.map((card, index) => (
                        <div className="card Allcard AllDashboard " key={index}>
                            <Link to={`/neet/dynamic-testseries/${card.Subject}`} state={{ subject: card.Subject, subjectId: card.Sn }} className='text-decoration-none text-black'>
                                <img src='https://api.insightdelhi.com/Upload/Course/6376938789465748031 (2).png' className="card-img-top" alt={card.Subject} style={{ height: "140px" }} />
                            </Link>
                            <div className="card-body All-bg">
                                <Link to={`/neet/dynamic-testseries/${card.Subject}`} state={{ subject: card.Subject, subjectId: card.Sn }} className='text-decoration-none text-black'>
                                    <p className="fw-bold overflow-hidde fs-5 text-uppercase " >{card.Subject}</p>
                                </Link>
                                <hr />
                                <div className="d-flex justify-content-between align-items-center">
                                    <Link to="#" className="card-link list-group-item">

                                    </Link>
                                    <Link to={`/neet/dynamic-testseries/${card.Subject}`} state={{ subject: card.Subject, subjectId: card.Sn }} className="btn-start list-group-item">CHOOSE PLAN</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>

    )
}

export default NeetTestSeriesCards